// src/modules/reports/components/table/ReportTableRow.tsx
import { Link } from "react-router-dom";
import { Report } from "../../models/report.model";
import { handleDateTime } from "@modules/shared/utils/handle-date.utils";
import { REPORT_TYPE } from "../../enums/report.enum";

interface ReportTableRowProps {
  report: Report;
}

export default function ReportTableRow({ report }: ReportTableRowProps) {
  const truncateText = (text: string, maxLength: number = 80) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  let targetId = report.target_id || "";
  if (
    report.report_type === REPORT_TYPE.PROFILE ||
    report.report_type === REPORT_TYPE.FEEDBACK
  ) {
    if (report.user_info?.target?.id) {
      targetId = report.user_info.target.id;
    }
  } else {
    if (report.target_info?.id) {
      targetId = report.target_info.id;
    }
  }

  const targetDisplay = report.target_display || report.target_id || "N/A";
  const breadcrumbLabel = truncateText(targetDisplay, 40);

  const typeLabel: Record<REPORT_TYPE, string> = {
    [REPORT_TYPE.POST]: "Bài viết",
    [REPORT_TYPE.COMMENT]: "Bình luận",
    [REPORT_TYPE.PROFILE]: "Hồ sơ",
    [REPORT_TYPE.FEEDBACK]: "Phản hồi",
  };

  // Chỉ truyền breadcrumbLabel và report, không truyền page
  const navigateState = { breadcrumbLabel, report };

  return (
    <tr>
      <td>
        <Link
          to={`/report/${targetId}`}
          state={navigateState}
          className="text-dark fw-medium text-decoration-none d-block"
          style={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={targetDisplay}
        >
          {truncateText(targetDisplay, 80)}
        </Link>
      </td>
      <td>
        <span className={`badge-custom type-${report.report_type}`}>
          {typeLabel[report.report_type] || report.report_type}
        </span>
      </td>
      <td>
        <span className={`badge-custom status-${report.status}`}>
          {report.status === "pending"
            ? "Đang chờ"
            : report.status === "resolved"
              ? "Đã xử lý"
              : "Từ chối"}
        </span>
      </td>
      <td>
        <span className={`badge-custom action-${report.action_taken}`}>
          {report.action_taken === "none"
            ? "Không có hành động"
            : report.action_taken === "hidden"
              ? "Ẩn"
              : "Xóa"}
        </span>
      </td>
      <td className="small text-muted">{handleDateTime(report.created_at)}</td>
      <td>
        {report.status === "pending" ? (
          <Link
            to={`/report/${targetId}`}
            state={navigateState}
            className="btn btn-primary btn-sm"
          >
            Xử lý
          </Link>
        ) : (
          <Link
            to={`/report/${targetId}`}
            state={navigateState}
            className="btn btn-outline-secondary btn-sm"
          >
            Xem
          </Link>
        )}
      </td>
    </tr>
  );
}
